import { injectable } from 'inversify';
import { action, makeObservable, observable } from 'mobx';

@injectable()
export class LearningGuideMenuItemState {
  @observable
  private _isBlinking = false;

  public constructor() {
    makeObservable(this);
  }
  
  @action
  public setBlinking(blinking: boolean): void {
    this._isBlinking = blinking;
  }

  public get isBlinking(): boolean {
    return this._isBlinking;
  }
}
